module.exports = __webpack_public_path__ + "static/media/6. Formas, Resina epóxica, 92 x 56 x 4 cm, 2020 copy.d1d9aa95.png";